module.exports = __webpack_public_path__ + "static/media/rounded-plus-grey-icon.79d16bad.svg";